export default __webpack_public_path__ + "static/media/banner01.bd15524b.png";